export default [
  {
    path: "/selling/ancillary",
    name: "SellingTariffAncillaryRate",
    component: () => import("@/components/master/sellingTariff/AncillaryRate"),
    meta: {
      title: "Booker Tariff - Ancillary Rate",
      requiresAuth: true,
      services: ["SellingTariffAncillaryRate"]
    }
  },
  {
    path: "/selling/chauffeur",
    name: "SellingTariffRentalChauffeurRate",
    component: () =>
      import("@/components/master/sellingTariff/RentalChauffeurRate"),
    meta: {
      title: "Booker Tariff - Chauffeur Rate",
      requiresAuth: true,
      services: ["SellingTariffRentalChauffeurRate"]
    }
  },
  {
    path: "/selling/hourly-chauffeur",
    name: "SellingTariffRentalChauffeurRate",
    component: () =>
      import("@/components/master/sellingTariff/HourlyChauffeurSelling"),
    meta: {
      title: "Booker Tariff - Chauffeur Rate",
      requiresAuth: true,
      services: ["SellingTariffRentalChauffeurRate"]
    }
  },
  {
    path: "/selling/hourly-chauffeur/:masterClassId",
    name: "SellingTariffRentalChauffeurRate",
    component: () =>
      import("@/components/master/sellingTariff/HourlyChauffeurRateSelling"),
    meta: {
      title: "Booker Tariff - Chauffeur Rate",
      requiresAuth: true,
      services: ["SellingTariffRentalChauffeurRate"]
    }
  },
  {
    path: "/selling/selfdrive",
    name: "SellingTariffRentalSelfDriveRate",
    component: () =>
      import("@/components/master/sellingTariff/RentalSelfDriveRate"),
    meta: {
      title: "Booker Tariff - Self Drive Rate",
      requiresAuth: true,
      services: ["SellingTariffRentalSelfDriveRate"]
    }
  },
  // {
  //   path: "/selling/transfer",
  //   name: "SellingTariffTransferRate",
  //   component: () => import("@/components/master/sellingTariff/TransferRate"),
  //   meta: {
  //     title: "Booker Tariff - Transfer Rate",
  //     requiresAuth: true,
  //     services: ["SellingTariffTransferRate"]
  //   }
  // },
  {
    path: "/selling/transfer",
    name: "SellingTariffTransferRate",
    component: () =>
      import("@/components/master/sellingTariff/TransferClassList"),
    meta: {
      title: "Booker Tariff - Transfer Rate",
      requiresAuth: true,
      services: ["SellingTariffTransferRate"]
    }
  },
  {
    path: "/selling/transfer/:masterClassId",
    name: "SellingTariffTransferRate",
    component: () =>
      import("@/components/master/sellingTariff/TransferRateList"),
    meta: {
      title: "Booker Tariff - Transfer Rate",
      requiresAuth: true,
      services: ["SellingTariffTransferRate"]
    }
  },
  {
    path: "/selling/surcharge",
    name: "SellingTariffSurcharge",
    component: () => import("@/components/master/sellingTariff/Surcharge"),
    meta: {
      title: "Booker Tariff - Surcharge",
      requiresAuth: true,
      services: [
        "SellingTariffGeneralSurcharge",
        "SellingTariffCancellationSurcharge",
        "SellingTariffPeakPeriodSurcharge",
        "SellingTariffWaitingTimeSurcharge"
      ]
    }
  },
  {
    path: "/selling/markup",
    name: "SellingTariffMarkup",
    component: () => import("@/components/master/sellingTariff/Markup"),
    meta: {
      title: "Booker Tariff - Markup",
      requiresAuth: true,
      services: ["SellingTariffMarkup"]
    }
  },
  {
    path: "/selling/incentive",
    name: "SellingTariffIncentive",
    component: () => import("@/components/master/sellingTariff/Incentive"),
    meta: {
      title: "Booker Tariff - Incentive",
      requiresAuth: true,
      services: ["SellingTariffIncentive"]
    }
  },
  {
    path: "/selling/company-incentive",
    name: "SellingTariffIncentiveCompany",
    component: () =>
      import("@/components/master/sellingTariff/IncentiveCompany"),
    meta: {
      title: "Booker Tariff - Company Incentive",
      requiresAuth: true,
      services: ["SellingTariffIncentiveCompany"]
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/sellingTariffModule.js